export default __webpack_public_path__ + "static/media/waiting-mobile.85189d95.webp";